import React, { useEffect, useState, useRef } from 'react'
import './AddServiceCenterComponent.css'
import { getStateList, getCityByState } from '../../actions/complaintsDataAction';
import { addNewServiceCenter} from '../../actions/serviceCenterActions';
import { useSelector, useDispatch } from 'react-redux';
import AccessRestricted from '../AccessRestricted';
import { useHistory } from 'react-router-dom'

function AddServiceCenterComponent() {

  const history = useHistory();
  const dispatch = useDispatch();
  let btnRef = useRef()

  useEffect(() => {
    dispatch(getStateList())
    document.getElementById('root').style.background = '#F5FBFB';
    document.querySelector('body').style.background = '#F5FBFB';
    return () => {
      document.getElementById('root').style.background = '#121212';
      document.querySelector('body').style.background = '#121212';
    }
  }, [])

  const handleBackButton = () => {
    history.push('/main-service-center');
  }

  const states = useSelector((state) => state.complaints.stateData.data);
  const cities = useSelector((state) => state.complaints.cityData.data);
  let response = useSelector((state) => state.serviceCenter.newServiceCenter2);
  if (response !== undefined) {
    if (response.success === true) {
      history.push('/main-service-center')
    }

    if (response.success === false) {
      btnRef.current.innerText = 'Save'
      btnRef.current.style.width = '130px';
      btnRef.current.removeAttribute("disabled");
    }
  }
  // if(JSON.stringify(response) !== JSON.stringify({}) && response !== undefined) {
  //   if(response.success === true) {
  //     return <Redirect to='/main-service-center' />
  //   }
  // }

  const initialValues = {
    firstName: '',
    lastName: '',
    serviceCenter: '',
    phone: '',
    companyEmail: '',
    recoveryEmail: '',
    address: '',
    pincode: '',
    stateCode: '',
    stateName: '',
    cityCode: '',
    cityName: '',
    gstin:'',
  }
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});

  const handleValidation = (scDetails) => {
    let errors = {}
    let validity = true;
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const mobileRegex = /^[6789]\d{9}$/;
    const pincodeRegex = /^[1-9]\d{5}$/;
    if (scDetails.firstName === undefined || scDetails.firstName === '') {
      errors['firstName'] = 'First name cannot be empty'
      validity = false
    } else if (scDetails.firstName.trim().length === 0) {
      errors['firstName'] = 'Please provide a valid first name'
      validity = false
    } else if (( /^[A-Za-z\s]*$/).test(scDetails.firstName) === false) {
      errors['firstName'] = 'Please provide valid first name'
      validity = false
    }
    if (scDetails.lastName === undefined || scDetails.lastName === '') {
      errors['lastName'] = 'Last name cannot be empty'
      validity = false
    } else if (scDetails.lastName.trim().length === 0) {
      errors['lastName'] = 'Please provide a valid last name'
      validity = false
    } else if ((/^[A-Za-z\s]*$/).test(scDetails.lastName) === false) {
      errors['lastName'] = 'Please provide a valid last name'
      validity = false        
    }
    if (scDetails.serviceCenter === undefined || scDetails.serviceCenter === '') {
      errors['serviceCenter'] = 'Service Center name cannot be empty'
      validity = false
    } else if (scDetails.serviceCenter.trim().length === 0) {
      errors['serviceCenter'] = 'Please provide a valid service center name'
      validity = false
    }
    if (scDetails.phone === undefined || scDetails.phone === '') {
      errors['phone'] = 'Phone number cannot be empty'
      validity = false;
    } else if (mobileRegex.test(scDetails.phone) === false) {
      errors['phone'] = 'Please enter valid contact number'
      validity = false
    }
    if (scDetails.companyEmail === undefined || scDetails.companyEmail === '') {
      errors['companyEmail'] = 'Company email cannot be empty'
      validity = false;
    } else if (emailRegex.test(scDetails.companyEmail) === false) {
      errors['companyEmail'] = 'Please enter valid company email'
      validity = false;
    }
    // if(scDetails.recoveryEmail === undefined || scDetails.recoveryEmail === '') {
    //   errors['recoveryEmail'] = 'Recovery email cannot be empty'
    //   validity = false;
    // }
    // else if(emailRegex.test(scDetails.companyEmail) === false) {
    //   errors['recoveryEmail'] = 'Please enter valid recovery email'
    //   validity = false;
    // }
    if (scDetails.address === undefined || scDetails.address === '') {
      errors['address'] = 'Address cannot be empty'
      validity = false;
    } else if (scDetails.address.trim().length === 0) {
      errors['address'] = 'Please provide a valid address'
      validity = false
    }
    if (scDetails.pincode === undefined || scDetails.pincode === '') {
      errors['pincode'] = 'Pincode cannot be empty'
      validity = false;
    } else if (pincodeRegex.test(scDetails.pincode) === false) {
      errors['pincode'] = 'Please provide a valid pincode'
      validity = false;
    }
    if (scDetails.stateCode === undefined || scDetails.stateCode === '') {
      errors['state'] = 'State cannot be empty'
      validity = false
    }
    if (scDetails.cityCode === undefined || scDetails.cityCode === '') {
      errors['city'] = 'City cannot be empty'
      validity = false;
    }
    if(scDetails.gstin===''||scDetails.gstin===undefined){
      errors['gstin']="GSTIN cannot be empty"
      validity = false;
    }
    setErrors(errors);
    return validity;
  }

  const postData = () => {
    let serviceCenterData = {
      "sc_name": values.serviceCenter,
      "email": values.companyEmail,
      "first_name": (values.firstName||'').trim(),
      "last_name": (values.lastName||'').trim(),
      "mobile": values.phone,
      "address": values.address,
      "pincode": values.pincode,
      "state_id": values.stateCode,
      "city_id": values.cityCode,
      "gstin":values.gstin
    }
    dispatch(addNewServiceCenter(serviceCenterData))
  }

  const handleSaveBtn = () => {
    let serviceCenterDetails = {
      firstName:(values.firstName||"").trim(),
      lastName: (values.lastName||"").trim(),
      serviceCenter: values.serviceCenter,
      phone: values.phone,
      companyEmail: values.companyEmail,
      gstin: values.gstin,
      address: values.address,
      pincode: values.pincode,
      stateCode: values.stateCode,
      stateName: values.stateName,
      cityCode: values.cityCode,
      cityName: values.cityName
    };
    let validity = handleValidation(serviceCenterDetails);
    if (validity === true) {
      if(btnRef.current) {
        btnRef.current.innerText = 'Please Wait...';
        btnRef.current.style.width = '150px';
        btnRef.current.setAttribute("disabled", "disabled");
      }
      
      postData()
    }
  }

  const getCityList = (e) => {
    const select = e.target;
    const desc = select.selectedOptions[0].text;
    setValues({
      ...values,
      stateCode: e.target.value,
      stateName: desc,
      cityCode: '',
      cityName: ''
    })
    let data = {
      "state_id": e.target.value
    }
    dispatch(getCityByState(data))
  }

  const handleCityChange = (e) => {
    const select = e.target;
    const desc = select.selectedOptions[0].text;
    setValues({
      ...values,
      cityCode: e.target.value,
      cityName: desc
    })
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  let userRoleId = localStorage.getItem('userRoleId');
  if (!['8'].includes(userRoleId)) {
    const style = {
      fontSize: "24px",
      color: "#000",
      textAlign: "center",
      fontWeight: "500",
      paddingTop: "5%"
    }
    return (<AccessRestricted style={style} />)
  } else {
    return (
      <React.Fragment>
        <div className='header pd headerNew'>
          <div className="backHome" onClick={handleBackButton}>
            <i className='fas fa-arrow-left'></i> Back to dashboard
          </div>
        </div>
        <div className='main-container main-container-new'>
          <div className='addEmployeeForm addServiceCenterForm'>
            <h1 className='form-heading'>Add new service center</h1>
            <div className='horizontal'></div>
            <form>
              <div className='row__two'>
                <div style={{ width: '330px' }}>
                  <label htmlFor='customer name'>First Name</label>
                  <input type="text" name='firstName' value={values.firstName} onChange={handleInputChange} />
                  <div className='error_add'>
                    <span className='errorShow'>{errors.firstName}</span>
                  </div>
                </div>
                <div>
                  <label htmlFor='customer name'>Last Name</label>
                  <input type="text" name='lastName' value={values.lastName} onChange={handleInputChange} />
                  <div className='error_add'>
                    <span className='errorShow'>{errors.lastName}</span>
                  </div>
                </div>
                <div>
                  <label htmlFor='service center name'>Service Center Name</label>
                  <input type='text' name='serviceCenter' value={values.serviceCenter} onChange={handleInputChange} />
                  <div className='error_add'>
                    <span className='errorShow'>{errors.serviceCenter}</span>
                  </div>
                </div>
              </div>
              <div className='row__oneNew'>
                <div>
                  <label htmlFor='customer name'>Contact number</label>
                  <input type="tel" name='phone' value={values.phone} maxLength="10" onChange={handleInputChange} />
                  <div className='error_add'>
                    <span className='errorShow'>{errors.phone}</span>
                  </div>
                </div>
                <div style={{ width: '310px' }}>
                  <label htmlFor="contact number">Company email ID</label>
                  <input type='email' className='addEmployeeInput' id='companyEmailInput' name='companyEmail'
                    value={values.companyEmail}
                    onChange={handleInputChange}
                    placeholder='@noise.com'
                  />
                  <div className='error_add'>
                    <span className='errorShow'>{errors.companyEmail}</span>
                  </div>
                </div>
                <div style={{ width: '370px' }}>
                  <label htmlFor='customer email'>GSTIN Number</label>
                  <input type='email' className='addEmployeeInput' name='gstin' value={values.gstin}
                    onChange={handleInputChange}
                    
                  />
                  <div className='error_add'>
                    <span className='errorShow'>{errors.gstin}</span>
                  </div>
                </div>
              </div>
              <div className='horizontal'></div>
              <div className='row__two'>
                <div>
                  <label htmlFor='customer address line 1'>Address</label>
                  <input type='text' name='address' value={values.address} onChange={handleInputChange} />
                  <div className='error_add'>
                    <span className='errorShow'>{errors.address}</span>
                  </div>
                </div>
              </div>
              <div className='row__threeNew'>
                <div>
                  <label htmlFor='pincode'>Pincode</label>
                  <input type='text' name='pincode' value={values.pincode} maxLength="6" onChange={handleInputChange} required={true} />
                  <div className='error_add'>
                    <span className='errorShow'>{errors.pincode}</span>
                  </div>
                </div>
                <div style={{ width: '310px' }}>
                  <label htmlFor='state'>State</label>
                  <select name='states' value={values.stateCode} onChange={getCityList}>
                    <option value=''>Select State</option>
                    {
                      states && states.map((state, index) => {
                        return <option key={state.id} value={state.id} text={state.state_name}>{state.state_name}</option>
                      })
                    }
                  </select>
                  <div className='error_add'>
                    <span className='errorShow'>{errors.state}</span>
                  </div>
                </div>
                <div style={{ width: '370px' }}>
                  <label htmlFor='city'>City</label>
                  <select name='cities' value={values.cityCode} onChange={handleCityChange}>
                    <option value=''>Select City</option>
                    {
                      cities && cities.map((city, index) => {
                        return <option key={city.id} value={city.id}>{city.city}</option>
                      })
                    }
                  </select>
                  <div className='error_add'>
                    <span className='errorShow'>{errors.city}</span>
                  </div>
                </div>
              </div>
            </form>
            <div className='horizontal'></div>
            <button style={{ float: "right" }} className='navBtn' id='addNewServiceCenterBtn' onClick={handleSaveBtn} ref={btnRef}>Save</button>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default AddServiceCenterComponent;